module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/help-to-buy-wales-560cd646f7ba36898916bbe7f47ca63f.png";